import React, { useEffect } from 'react';
import { Form } from 'antd';

import { setStaticFormValuesFromFilter } from '../../common/filterHelpers';
import { SearchFormProps } from '../../common/searchFormField.types';
import { FormDatePicker } from '../../components/forms/FormDatePicker';
import { FormDoubleInput } from '../../components/forms/FormDoubleInput';
import { FormInput } from '../../components/forms/FormInput';
import { StyledColumn } from '../../components/StyledColumn';

export const EmailsSearchForm: React.FC<SearchFormProps> = ({ form, filter }) => {
  useEffect(() => setStaticFormValuesFromFilter(form, filter), [filter, form]);

  return (
    <Form form={form} style={{ flexGrow: '1' }} layout="vertical" colon={false}>
      <StyledColumn gap="0.5rem">
        <FormInput name="from" label="From" />

        <FormDoubleInput
          leftInput={<FormDatePicker name={['sentDate', 'start']} label="Sent from" />}
          rightInput={<FormDatePicker name={['sentDate', 'end']} label="Sent to" />}
          withDivider
        />

        <FormInput name="subject" label="Subject" />
        <FormInput name="body" label="Body" />
      </StyledColumn>
    </Form>
  );
};
